// auth action types
export const CONTRACTORS_DATA_LOADED = 'CONTRACTORS_DATA_LOADED';

export default {
  CONTRACTORS_DATA_LOADED
};